<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    width="95.2598mm"
    height="68.9846mm"
    version="1.1"
    style="
      shape-rendering: geometricPrecision;
      text-rendering: geometricPrecision;
      image-rendering: optimizeQuality;
      fill-rule: evenodd;
      clip-rule: evenodd;
    "
    viewBox="0 0 100 120"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <filter height="200%" width="200%" y="-50%" x="-50%" id="relieve">
        <feGaussianBlur result="blur1" stdDeviation="5" in="offset1" />
        <feGaussianBlur result="blur2" stdDeviation="3" in="offset2" />
      </filter>
      <linearGradient y2="100%" x2="100%" y1="0%" x1="0%" id="gradienteRelieve">
        <stop stop-color="#435052" offset="0%" />
        <stop stop-color="#ffffff" offset="100%" />
      </linearGradient>
    </defs>
    <g id="torre-carcel">
      <!-- Base de la torre -->
      <path
        class="fil0"
        d="M 25 120 L 75 120 L 72 85 L 28 85 Z"
      />
      <!-- Cuerpo principal de la torre -->
      <path
        class="fil0"
        d="M 32 85 L 68 85 L 68 45 L 32 45 Z"
      />
      <!-- Barrotes (rejas) -->
      <path
        class="fil0"
        d="M 35 72 L 38 72 L 38 58 L 35 58 Z M 42 72 L 45 72 L 45 58 L 42 58 Z M 49 72 L 52 72 L 52 58 L 49 58 Z M 56 72 L 59 72 L 59 58 L 56 58 Z M 63 72 L 66 72 L 66 58 L 63 58 Z"
      />
      <!-- Mirador / cabina superior -->
      <path
        class="fil0"
        d="M 28 45 L 72 45 L 75 28 L 25 28 Z"
      />
      <!-- Ventana del mirador -->
      <path
        class="fil0"
        d="M 38 40 L 62 40 L 62 32 L 38 32 Z"
      />
      <!-- Techo en forma de cúpula / torreón -->
      <path
        class="fil0"
        d="M 50 0 L 78 28 L 22 28 Z"
      />
      <!-- Cruz de búsqueda o foco (detalle superior) -->
      <path
        class="fil0"
        d="M 50 12 L 52 22 L 50 20 L 48 22 Z"
      />
    </g>
  </svg>
</template>
<script>
import Vue from 'vue';

export default Vue.extend();
</script>

<style type="text/css" scoped>
.fil0 {
  fill: url(#gradienteRelieve);
}
</style>
